<div class="white-bg no-padding no-margin">
  <breadcrumbs>
    <breadcrumb route="/" label="{{Translate('Dashboard')}}"></breadcrumb>
    <breadcrumb [currentRoute]="true" label="{{Translate('Inventory')}}"></breadcrumb>
  </breadcrumbs>
</div>

<div class="panel panel--components" style=" margin-left: 20px; margin-right: 20px; padding-top: 16px;">
  <div *ngIf="!isSearchVisible" class="search-toggle-container"
       style="margin-bottom:20px;  margin-left: 20px; margin-right: 20px;">
    <button mat-raised-button color="warn" (click)="isSearchVisible = true">
      <!-- <mat-icon>Expand</mat-icon>  -->
      {{'Expand' | translate | async}}
    </button>

    <mat-form-field class="search-input">
      <input type="text" placeholder="{{Translate('Select Customer')}}" (input)="customerChanged($event)" matInput name="inputcustomer"
             [matAutocomplete]="auto2" [(ngModel)]="customerModel">
      <mat-autocomplete #auto2="matAutocomplete"
                        (optionSelected)="onSelectCustomer($event.option)">
        <mat-option [value]="customer.Title" *ngFor="let customer of _dropDownListsFiltered.customerList ">
          {{customer.Title}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="search-input">
      <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite"
                  placeholder="{{Translate('Select Job Site')}}">
        <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
          {{ jobsite.Title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="search-input">
      <mat-select (selectionChange)="typeChanged($event)" [(value)]="selectedType" name="make"
                  placeholder="{{Translate('Select Type')}}">
        <mat-option>None</mat-option>
        <mat-option *ngFor="let make of _dropDownLists.type" [value]="make.Id">
          {{ make.Title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="search-input">
      <mat-select (selectionChange)="changedInventoryStatus($event)" [(value)]="selectedStatus" name="status"
                  placeholder="{{Translate('Select Status')}}">
        <mat-option>None</mat-option>
        <mat-option *ngFor="let make of _dropDownLists.inventoryStatus" [value]="make.Id">
          {{ make.Title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <a class="button" style="margin-left: 15px; margin-right: 5px;" (click)="ResetFields();"><span class="button__text">{{'Reset' | translate | async}}</span></a>
    <a class="button button--primary" (click)="searchRecords()">
      <i class="material-icons button__icon">search</i><span class="button__text">{{'Search' | translate | async}}</span>
    </a>
  </div>

  <div class="panel__header" *ngIf="isSearchVisible">
    <span class="panel__header__title">
      <button mat-icon-button (click)="isSearchVisible = false">
        <mat-icon>close</mat-icon>
      </button>
      {{Translate('Search')}}
    </span>
  </div>
  <mat-card *ngIf="isSearchVisible">
    <div class="row">
      <mat-form-field class="search-input">
        <input type="text" placeholder="{{Translate('Select Customer')}}" (input)="customerChanged($event)" matInput name="inputpCustomer"
               [matAutocomplete]="auto2" [(ngModel)]="customerModel">
        <mat-autocomplete #auto2="matAutocomplete"
                          (optionSelected)="onSelectCustomer($event.option)">
          <mat-option [value]="customer.Title" *ngFor="let customer of _dropDownListsFiltered.customerList ">
            {{customer.Title}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="search-input">
        <input type="text" placeholder="{{Translate('Select Make')}}" (input)="changedMake($event)" matInput name="inputMake"
               [matAutocomplete]="auto1" [(ngModel)]="makeModel">
        <mat-autocomplete #auto1="matAutocomplete"
                          (optionSelected)="onSelectMake($event.option)">
          <mat-option [value]="make.Title" *ngFor="let make of _dropDownListsFiltered.makeList">
            {{make.Title}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="search-input">
        <mat-select (selectionChange)="typeChanged($event)" [(value)]="selectedType" name="make"
                    placeholder="{{Translate('Select Type')}}">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let make of _dropDownLists.type" [value]="make.Id">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="search-input">
        <input matInput [(ngModel)]="listFilter" type="text" placeholder="{{Translate('Filter By Serial Number')}}" />
      </mat-form-field>

      <mat-form-field class="search-input">
        <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite"
                    placeholder="{{Translate('Select Job Site')}}">
          <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
            {{ jobsite.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="search-input">
        <input type="text" placeholder="{{Translate('Select Model')}}" (input)="changedModel($event)" matInput name="inputModel"
               [matAutocomplete]="auto" [(ngModel)]="machineModel">
        <mat-autocomplete #auto="matAutocomplete"
                          (optionSelected)="onSelcetionModel($event.option)">
          <mat-option [value]="model.Title" *ngFor="let model of _dropDownListsFiltered.modelList ">
            {{model.Title}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="search-input">
        <mat-select (selectionChange)="changedInventoryStatus($event)" [(value)]="selectedStatus" name="status"
                    placeholder="{{Translate('Select Status')}}">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let make of _dropDownLists.inventoryStatus" [value]="make.Id">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="seacrch-panel">
        <div class="search-checkboxes">
          <div>
            <mat-checkbox style="margin-left: 1%" [checked]="ShowBoth" *ngIf="SystemId==0" (change)="getBoth()"
                          [(ngModel)]="ShowBoth">
              {{'Include Inventory on Equipment' | translate | async}}
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox style="margin-left: 1%" [checked]="showRelatedModel" (change)="showRelated()"
                          [(ngModel)]="showRelatedModel">
              {{'Include Related Models' | translate | async}}
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox style="margin-left: 1%" [checked]="excludeScrap" (change)="showRelated()"
                          [(ngModel)]="excludeScrap">
              {{'Exclude "Scrap"' | translate | async}}
            </mat-checkbox>
          </div>
        </div>
        <div class="search-button-div">
          <div style="padding-right: 20px;">
            <a class="button button--primary" (click)="openReport()">
              <span class="material-icons button__icon">picture_as_pdf</span>
              <span class="button__text">
                {{ 'Inventory Report' | translate | async }}
              </span>
            </a>
          </div>
          <div class="search-button-div">
            <a class="button" (click)="ResetFields();">
              <span class="button__text">
                {{
'Reset' | translate |
                async
                }}
              </span>
            </a>
            <a class="button button--primary" (click)="searchRecords()">
              <i class="material-icons button__icon">search</i><span class="button__text">
                {{
'Search' | translate |
                async
                }}
              </span>
            </a>
          </div>
        </div>
      </div>
     
    </div>
  </mat-card>
</div>
<div style=" margin-left: 20px; margin-right: 20px;">
  <!-- <div *ngIf="isOptionsVisible" >
     <button mat-icon-button (click)="isOptionsVisible=false">
         <mat-icon class="icon_font_size">arrow_drop_up</mat-icon>
     </button>
   </div>
  <div *ngIf="!isOptionsVisible">
     <button mat-raised-button color="warn" (click)="isOptionsVisible=true">
       {{'Tools & Actions' | translate | async}}
     </button>
   </div> -->
  <div class="table-row">
    <div class="flex columns div-margin-top ">
      <div class="panel panel--next-inspection">
        <div class="panel__header">
          <div style="display: block; margin-right: 10px;">
            <button mat-icon-button (click)="isOptionsVisible=!isOptionsVisible">
              <mat-icon *ngIf="isOptionsVisible" class="icon_font_size">arrow_drop_up</mat-icon>
              <mat-icon *ngIf="!isOptionsVisible" class="icon_font_size">arrow_drop_down</mat-icon>
            </button>
            <span class="panel__header__title">
              {{'Task List' | translate | async}}
            </span>
          </div>
          <div class="header-actions" *ngIf="!isOptionsVisible">
            <button mat-icon-button (click)="gotoScreen(1)" matTooltip="{{'Chain to Inventory' | translate | async}}">
              <mat-icon>link</mat-icon>
            </button>
            <button mat-icon-button (click)="gotoScreen(2)" matTooltip="{{'Frame to Inventory' | translate | async}}">
              <mat-icon>inventory</mat-icon>
            </button>
            <button mat-icon-button (click)="gotoScreen(3)" matTooltip="{{'Idler to Inventory' | translate | async}}">
              <mat-icon>add_task</mat-icon>
            </button>
          </div>
        </div>
        <div class="panel__content flex flex--align-stretch" [class.toggle-display-options]="isOptionsVisible"
             [@enterAnimation] *ngIf="isOptionsVisible">
          <a class="square-button" style="margin-right: 20px;" (click)="gotoScreen(1)">
            <i class="material-icons square-button__icon">link</i>
            <span class="square-button__label">{{'Chain to Inventory' | translate | async}}</span>
          </a>
          <a class="square-button" style="margin-right: 20px;">
            <i class="material-icons square-button__icon" (click)="gotoScreen(2);">inventory</i>
            <span class="square-button__label">{{'Frame to Inventory' | translate | async}}</span>
          </a>
          <a class="square-button" (click)="gotoScreen(3)">
            <i class="material-icons square-button__icon">add_task</i>
            <span class="square-button__label">{{'Idler to Inventory' | translate | async}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="center" [hidden]="!isLoading">
  <mat-spinner></mat-spinner>
</div>
<div class="panel panel--components" style=" margin-left: 20px; margin-right: 20px;" [@fadeInOut]
     [hidden]="isLoading || items?.length ===0">
  <!--<div class="panel__header">
      <span class="panel__header__title">
        {{
  Translate('Inventory')
        }}
      </span>
    </div>-->
  <div class="panel__content no-padding sticky" *ngIf="filteredSystems?.length > 0">
    <table class="table table--striped table--full-width">
      <thead>
        <tr>
          <th rowspan="2">{{'Customer' | translate | async}}</th>
          <th rowspan="2">{{'Jobsite' | translate | async}}</th>
          <th rowspan="2">{{'Make' | translate | async}}</th>
          <th rowspan="2">{{'Model' | translate | async}}</th>
          <th rowspan="2">{{'Family' | translate | async}}</th>
          <th rowspan="2">{{'Side' | translate | async}}</th>
          <th rowspan="2">{{'Type' | translate | async}}</th>
          <th rowspan="2">{{'Serial#' | translate | async}}</th>
          <th rowspan="2" style="white-space: nowrap;">{{'Equip Unit#' | translate | async}}</th>
          <th rowspan="2" style="white-space: nowrap;">{{'Last Insp. Date' | translate | async}}</th>
          <th rowspan="2">{{'Examiner' | translate | async}}</th>
          <th rowspan="2">{{'Status' | translate | async}}</th>
          <th rowspan="2">{{'PDF' | translate | async}}</th>
          <th [attr.colspan]="componentColumns.length">% Worn</th>
        </tr>
        <tr class="tab-second-th">
          <th class="align" *ngFor="let col of componentColumns">
            {{ col.DisplayName | translate | async }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row-style" *ngFor="let item of filteredSystems" style="cursor: pointer;">
          <td (click)="openSelcetionDilaogInspect(item)">{{item.CustomerName}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.JobsiteName}} </td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.MakeDesc}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.ModelDesc}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.TypeFamilyName}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.Side}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.SystemTypeName}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.SerialNumber}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.eqUnit}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.LastInspectionDate | date:'dd/MMM/yyyy'}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.Examiner | aesDecrypt}}</td>
          <td (click)="openSelcetionDilaogInspect(item)">{{item.InventoryStatus}}</td>
          <td>
            <mat-icon [ngClass]="{    'mat-warn': item.InventoryStatusId != 7,    'disabled-icon': item.InventoryStatusId == 7  }"
                      [matTooltip]="getRepairTooltip(item)" (click)="item.InventoryStatusId != 7 && downloadPDF(item)">
              picture_as_pdf
            </mat-icon>
          </td>
          <ng-container *ngFor="let col of componentColumns">
            <td class="align" (click)="openSelcetionDilaogInspect(item)">
              {{ getComponentValue(item,col.ComponentName,col.PositionNo, col.ComponentTypeId)==0 ? '-' : getComponentValue(item,col.ComponentName,col.PositionNo, col.ComponentTypeId).toFixed(1) }}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="custom-paginator">

    <div class="page-size">
      <span>{{'Items per page' | translate | async}}:</span>
      <button mat-button [matMenuTriggerFor]="pageSizeMenu" class="page-size-btn">
        {{ inventoryPerPage }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #pageSizeMenu="matMenu" yPosition="above">
        <button mat-menu-item (click)="changePageSize(10)">10</button>
        <button mat-menu-item (click)="changePageSize(25)">25</button>
        <button mat-menu-item (click)="changePageSize(50)">50</button>
        <button mat-menu-item (click)="changePageSize(100)">100</button>
      </mat-menu>
    </div>

    <mat-paginator [hidePageSize]="true"
                   [pageIndex]="pageNumber"
                   [length]="totalResults"
                   [pageSize]="inventoryPerPage"
                   (page)="onPageEvent($event)">
    </mat-paginator>

  </div>

  <!--<mat-paginator [pageIndex]="pageNumber" [length]="totalResults" [pageSize]="inventoryPerPage"
                 [pageSizeOptions]="[10, 25, 50, 100]" (page)="onPageEvent($event)">
  </mat-paginator>-->
</div>
